export function clientResource(data) {
    return {
        name: data.name,
        id: data.id,
        startWork: data.startWork
    };
}
